import { useCallback, useEffect, useState } from "react";
import { SalePlanParamValueType, SalePlanType } from "../redux/Sale/Plan/types";
import { LicenseProductParam } from "../redux/Sale/License/types";
import { isNumeric } from "../helpers/functions";

export const useFareRestriction = (
    currentPlanData: SalePlanType | undefined | null,
    restrictionCode: LicenseProductParam,
    currentValue: number | undefined | null = null
) => {
    const [upgradeFare, setUpgradeFare] = useState<boolean>(false);
    const [currentPlan, setCurrentPlan] = useState<SalePlanType | null>(null);

    const checkFareRestriction = useCallback((plan: SalePlanType) => {
        const restrictionValue = plan?.productParamValues?.find((param: SalePlanParamValueType) =>
            param.productParam.code === restrictionCode
        );

        if (restrictionValue === undefined) {
            setUpgradeFare(false);
        } else {
            if (isNumeric(restrictionValue.value) && isNumeric(currentValue)) {
                setUpgradeFare(!(parseInt(restrictionValue.value) >= currentValue));
            } else {

                setUpgradeFare(
                    !isNumeric(restrictionValue.value)
&&
                    (restrictionValue.value !== "Y"));
            }
        }
    }, [restrictionCode, currentValue]);

    useEffect(() => {
        if (currentPlanData?.uuid !== currentPlan?.uuid) {
            setCurrentPlan(currentPlanData ? { ...currentPlanData } : null);
        }
        if (currentPlanData) {
            checkFareRestriction(currentPlanData);
        }
    }, [currentPlanData, currentPlan?.uuid, checkFareRestriction]);

    return { upgradeFare, setUpgradeFare };
};